<footer class="footer pb-0" *transloco="let t">
  <div class="container-fluid">
    <div class="row pb-4">
      <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
        <img class="footer-logo ms-md-5" src="assets/img/logo/iSophi_podpora_pedagoga.svg" alt="iSophi PAP logo" />
      </div>
      <div class="col-12 col-md-4 mt-3 d-flex align-items-center justify-content-center">
        <div class="quote text-center">
          <p class="mb-1">{{ t('shared/quote') }}</p>
          <p class="font-weight-bold">{{ t('shared/quoteAuther') }}</p>
        </div>
      </div>
      <div class="col-12 col-md-4 mt-3 d-flex align-items-center justify-content-center">
        <p class="text-center text-md-start">
          <span class="font-weight-bold">{{ t('shared/stayInTouch') }}</span
          ><br />
          <a href="mailto:info@isophi.cz" rel="noopener noreferrer" target="_blank">info&#64;isophi.cz</a>
        </p>
      </div>
    </div>
    <div class="row align-items-center border-top p-4">
      <div class="col-md-12 col-sm-12 mt-3 mt-lg-0 text-center">
        <small class="d-block text-muted"> &copy; 2025 STEP, {{ t('shared/version') }} {{ version }} {{ envShortcut }} </small>
      </div>
    </div>
  </div>
</footer>
